export interface SupportOperationFailure {
  operationName: string
  correlationId: string
  startedAt: number
  failedAt: number
  pageKey: string
}

/** Shared allowlist for launch state and recovered drafts. Not source authority. */
export function sanitizeSupportFailureEvidence(
  value: unknown
): SupportOperationFailure | undefined {
  if (!value || typeof value !== 'object') return undefined
  const input = value as Partial<SupportOperationFailure>
  if (
    typeof input.operationName !== 'string' ||
    !/^[A-Za-z_][A-Za-z0-9_]{0,127}$/.test(input.operationName) ||
    typeof input.correlationId !== 'string' ||
    !/^[0-9a-f]{32}$/.test(input.correlationId) ||
    /^0+$/.test(input.correlationId) ||
    typeof input.pageKey !== 'string' ||
    !/^[a-z][a-z0-9.]{0,63}$/.test(input.pageKey) ||
    typeof input.startedAt !== 'number' ||
    !Number.isFinite(input.startedAt) ||
    input.startedAt < 0 ||
    typeof input.failedAt !== 'number' ||
    !Number.isFinite(input.failedAt) ||
    input.failedAt < input.startedAt ||
    input.failedAt - input.startedAt > 300000
  )
    return undefined
  return {
    operationName: input.operationName,
    correlationId: input.correlationId,
    startedAt: input.startedAt,
    failedAt: input.failedAt,
    pageKey: input.pageKey
  }
}
